(ns app.strive-forms.question-fields.number-scale
  (:require [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as events]
            [app.strive-forms.helper-functions :refer [get-default-text-val
                                                       maybe-scroll-down!
                                                       scroll-to-next-required-field! update-preview-panel!]]
            [app.strive-forms.styles :refer [num-scale-button-wrapper-style
                                             num-scale-underline-style
                                             number-scale-button number-scale-label-style number-scale-labels-component-style
                                             numbers-scale-component-style selected-number-scale-button]]
            [clojure.string :as s]
            [re-com.core :refer [v-box]]
            [re-frame.core :as re-frame]
            [reagent.core :as r]))



(defn select-on-click! [{:keys [input-data field-id value-selected regenerate-display-fields num-scale-button-disabled? val-selected
                                text-val selected? is-multi-question? current-page index event missing-required-fields steps-total cache-data]}]
  (regenerate-display-fields
   (update input-data (keyword field-id) (fn [value]
                                           (assoc value :value value-selected))))
  (re-frame/dispatch [::events/update-input-local
                      {:input-data input-data :key (keyword field-id) :value value-selected}])
  (cache-data (update input-data (keyword field-id) (fn [value]
                                                      (assoc value :value value-selected))))
  (if (zero? (count @missing-required-fields))
    (do (maybe-scroll-down! {:event event :index index
                             :bottom-percentage-of-page (:scroll-down-condition default-values)})
        (when-not is-multi-question? (reset! current-page (+ 1 index))))
    (scroll-to-next-required-field! {:missing-required-fields missing-required-fields :field-id field-id
                                     :current-page current-page :is-multi-question? is-multi-question?
                                     :steps-total steps-total}))

  (reset! num-scale-button-disabled? false)
  (reset! val-selected value-selected)
  (reset! text-val value-selected)
  (reset! selected? true))

(defn- deselect-on-click! [{:keys [input-data field-id regenerate-display-fields num-scale-button-disabled? selected? text-val val-selected]}]
  [(re-frame/dispatch [::events/update-input-local
                       {:input-data input-data :key (keyword field-id) :value nil}])
   (regenerate-display-fields
    (update input-data (keyword field-id) (fn [value]
                                            (assoc value :value nil))))
   (reset! num-scale-button-disabled? false)
   (reset! selected? false)
   (reset! text-val nil)
   (reset! val-selected nil)])

(defn- on-click-select-val [{:keys [value-selected text-val input-data field-id regenerate-display-fields index event
                                    num-scale-button-disabled? selected? val-selected is-multi-question? current-page 
                                    missing-required-fields steps-total cache-data]}]
  (if (not= value-selected @val-selected)
    (select-on-click! {:input-data input-data :field-id field-id :event event
                       :value-selected value-selected :regenerate-display-fields regenerate-display-fields
                       :num-scale-button-disabled? num-scale-button-disabled? :val-selected val-selected :index index
                       :text-val text-val :selected? selected? :is-multi-question? is-multi-question? :current-page current-page
                       :missing-required-fields missing-required-fields :steps-total steps-total :cache-data cache-data})

    (deselect-on-click! {:input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                         :num-scale-button-disabled? num-scale-button-disabled? :selected? selected? :text-val text-val
                         :val-selected val-selected})))

(defn- get-selected-style [{:keys [index pre-filled value-selected input-data field-id text-val theme-data val-selected]}]
  (if (or (= value-selected @val-selected) (and (zero? index) (not= nil pre-filled) (= value-selected (int pre-filled)))
          (= value-selected @text-val))
    (selected-number-scale-button {:background-color (str (:answers_background_color theme-data) "60")
                                   :border-color   (:answers_border_color theme-data "#9c9ea8")
                                   :answer-color (:answers_color theme-data)
                                   :buttons-color (:buttons_color theme-data)
                                   :buttons-text-color (:buttons_text_color theme-data)})
    (number-scale-button {:background-color (str (:answers_background_color theme-data) "60")
                          :border-color (if (nil? (:answers_border_color theme-data))
                                          "#9c9ea8"
                                          (:answers_border_color theme-data))
                          :answer-color (:answers_color theme-data)
                          :buttons-color (:buttons_color theme-data)
                          :buttons-text-color (:buttons_text_color theme-data)})))

(defn get-color-indicator [{:keys [num max-value]}]
  (let [detractor-color (:detractor (:nps-indicator-color default-values))
        passive-color (:passive (:nps-indicator-color default-values))
        promoter-color (:promoter (:nps-indicator-color default-values))]
    (cond
      (and (= "10" max-value) (< num 7)) detractor-color
      (and (= "10" max-value) (> num 6) (< num 9)) passive-color
      (and (= "10" max-value) (> num 8) (< num 11)) promoter-color
      (and (= "5" max-value) (< num 4)) detractor-color
      (and (= "5" max-value) (= num 4)) passive-color
      (and (= "5" max-value) (> num 4)) promoter-color)))

(defn- width-for-number-button [count-of-buttons]
  (let [galaxy-fold-conditions (< (.-innerWidth js/window) 290)
        galaxy-s8-conditions (and (> (.-innerWidth js/window) 290) (< (.-innerWidth js/window) 370))
        regular-phone-view-conditions (and (> (.-innerWidth js/window) 370) (< (.-innerWidth js/window) 800))]
    (cond galaxy-fold-conditions (str (/ 100 4.54) "%")
          galaxy-s8-conditions (str (/ 100 6) "%")
          regular-phone-view-conditions (str (/ 100 7) "%")
          :else (str (/ 100 count-of-buttons) "%"))))

(defn- number-button-component [{:keys [count-of-buttons index pre-filled  input-data field-id selected? max-value
                                        text-val theme-data val-selected regenerate-display-fields num-scale-button-disabled?
                                        default-button-text default-button-value is-multi-question? current-page
                                        is-nps? missing-required-fields steps-total cache-data]}]
  ^{:key (str default-button-value field-id)}
  [:div
   {:class (num-scale-button-wrapper-style {:width (width-for-number-button count-of-buttons)})}
   [:button {:class (get-selected-style {:index index :pre-filled pre-filled :value-selected default-button-value
                                         :input-data input-data :field-id field-id
                                         :text-val text-val :theme-data theme-data
                                         :val-selected val-selected})

             :on-click (fn [event]
                         (on-click-select-val {:value-selected default-button-value :text-val text-val :input-data input-data
                                               :field-id field-id :regenerate-display-fields regenerate-display-fields
                                               :num-scale-button-disabled? num-scale-button-disabled? :index index
                                               :is-multi-question? is-multi-question? :current-page current-page
                                               :selected? selected? :val-selected val-selected
                                               :event event :missing-required-fields missing-required-fields
                                               :steps-total steps-total :cache-data cache-data}))} default-button-text]
   (when (and is-nps? (not= default-button-value "-1"))
     [:div {:style {:height "7px"}}
      [:div {:class (num-scale-underline-style {:background-color (get-color-indicator {:num default-button-value
                                                                                        :max-value max-value})})}]])])



(defn number-scale-field [{:keys [field selected-language regenerate-display-fields input-data field-id default-value current-page index cache-data]}]
  [:div (:id field)]
  (let [max-value (if (nil? (:maximum (:additional_settings field)))
                    10
                    (:maximum (:additional_settings field)))
        min-value (if (nil? (:minimum (:additional_settings field)))
                    0
                    (:minimum (:additional_settings field)))

        num-scale-button-disabled? (r/atom true)
        enable_na (:score_na (:additional_settings field) false)
        na_value (:na_value (:opinion_scale default-values))
        is-nps? (= (:score_type field) "nps")
        na_text (:na_text (:opinion_scale default-values))
        default-value-int (if (some? default-value) (int default-value) nil)
        text-val (r/atom (get-default-text-val {:input-data input-data :field-id field-id
                                                :default-value default-value-int
                                                :current-page @current-page :index index
                                                :num-scale-initial? true}))
        count-of-buttons (if enable_na (+ (count (range (int min-value) (+ (int max-value) 1))) 1)
                             (count (range (int min-value) (+ (int max-value) 1))))]
    (fn [{:keys [field-id index theme-data input-data pre-filled  is-multi-question? current-page selected-language missing-required-fields steps-total]}]
      (let [selected? (r/atom false)
            val-selected (r/atom (:value (get input-data (keyword field-id))))
            min-value-label (when-not (nil? ((keyword selected-language) (:minimum_label_obj (:additional_settings field))))
                              ((keyword selected-language) (:minimum_label_obj (:additional_settings field))))
            max-value-label (when-not (nil? ((keyword selected-language) (:maximum_label_obj (:additional_settings field))))
                              ((keyword selected-language) (:maximum_label_obj (:additional_settings field))))
            default-value (r/atom (get-default-text-val {:input-data input-data :field-id field-id
                                                         :default-value default-value-int
                                                         :current-page @current-page :index index}))]
        (update-preview-panel! {:input-data input-data :field-id field-id
                                :value-to-update @default-value
                                :condition (not (s/blank? @default-value))}) 
        [v-box
         :justify :center
         :width "100%"
         :align :center
         :children [[:div
                     {:class (numbers-scale-component-style {:width (if (< (.-innerWidth js/window) 800)
                                                                      (str (- 100 (/ 100 7)) "%")
                                                                      "736px")
                                                             :flex-wrap (when (< (.-innerWidth js/window) 800) "wrap")})
                      :id (str  "number-scale-" (:id field))}
                     (doall (for [x (range (int min-value) (+ (int max-value) 1))]
                              (number-button-component {:count-of-buttons count-of-buttons :index index :pre-filled pre-filled
                                                        :input-data input-data :field-id field-id :text-val text-val :max-value max-value
                                                        :theme-data theme-data :val-selected val-selected :regenerate-display-fields regenerate-display-fields
                                                        :num-scale-button-disabled? num-scale-button-disabled? :selected? selected?
                                                        :is-multi-question? is-multi-question? :current-page current-page
                                                        :default-button-text x :default-button-value x :is-nps? is-nps?
                                                        :missing-required-fields missing-required-fields :steps-total steps-total :cache-data cache-data})))

                     (when enable_na
                       (number-button-component {:count-of-buttons count-of-buttons :index index :pre-filled pre-filled
                                                 :input-data input-data :field-id field-id :text-val text-val :max-value max-value
                                                 :theme-data theme-data :val-selected val-selected :regenerate-display-fields regenerate-display-fields
                                                 :num-scale-button-disabled? num-scale-button-disabled? :selected? selected?
                                                 :is-multi-question? is-multi-question? :current-page current-page
                                                 :default-button-text na_text :default-button-value na_value :missing-required-fields missing-required-fields
                                                 :steps-total steps-total :cache-data cache-data}))]
                    [:div
                     {:class (number-scale-labels-component-style {:width (if (< (.-innerWidth js/window) 800)
                                                                            "100%"
                                                                            (if enable_na (if (> (int max-value) 5) "680px" "613px") "736px"))
                                                                   :color (:answers_color theme-data)
                                                                   :align-self "start"})
                      :id (str "number-scale-label" (:id field))}
                     [:p {:class (number-scale-label-style {:font-size (if is-multi-question? "12px" "16px")})} min-value-label]
                     [:p {:class (number-scale-label-style {:font-size (if is-multi-question? "12px" "16px")})} max-value-label]]]]))))
